import * as PropTypes from 'prop-types';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';

function StructuredFieldHeader({fieldDefinition}: StructuredFieldHeaderProps): JSX.Element {
  return (
    <Tooltip title={fieldDefinition.tableName}>
      <span>{fieldDefinition.name}</span>
    </Tooltip>
  );
}

interface StructuredFieldHeaderProps {
  fieldDefinition: {
    tableName: string;
    name: string;
  };
}

StructuredFieldHeader.propTypes = {
  fieldDefinition: PropTypes.shape({
    tableName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default StructuredFieldHeader;
